import React, { createContext, useState } from "react";

const  AuthContext = createContext({});

function AuthProvider(props){
    let isLogado = localStorage.getItem('logado');
    const [logado, setLogado] = useState(isLogado === "S" ? true : false);
    const [idUsuario, setIDUsuario] = useState(0);
    const [nomeUsuario, setNomeUsuario] = useState('');
    const [emailUsuario, setEmailUsuario] = useState('');
    const [nomeEmpresa, setNomeEmpresa] = useState('');

    const [empresas, setEmpresas] = useState([]);

    return(

      <AuthContext.Provider value={{
        logado, setLogado, idUsuario, setIDUsuario, nomeUsuario, setNomeUsuario, emailUsuario, setEmailUsuario,
         empresas, setEmpresas, nomeEmpresa, setNomeEmpresa
        
      }}>
        {props.children}
        
      </AuthContext.Provider>
      
    )

}

export {AuthContext, AuthProvider}